<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-checkbox label="Pokaż wykorzystane" v-model="showZuzyte"></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :items="voucherList"
            :loading="loading"
            :headers="headers">
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwa}}</td>
              <td>{{getTypOpis(props.item)}}</td>
              <td>{{props.item.numer}}</td>
              <td>{{props.item.kwota}} zł</td>
              <td>{{dateTimeFormat(props.item.data_sprzedazy,true,'')}}</td>
              <td>{{dateTimeFormat(props.item.kiedy_wygasa,false,'Bezterminowy')}}</td>
              <td>{{getWartosc(props.item)}}</td>
              <td>{{props.item.sprzedawca}}</td>
              <td>{{props.item.zuzyty ? 'TAK' : 'NIE'}}</td>
              <td>
                <v-icon small class="mr-2" v-if="$can('do','POKO_VoucheryUsuwanieSprzedanego')"  @click="removeVoucher(props.item)" title="Usuń voucher">fa-trash-alt</v-icon>
                <v-icon small class="mr-2" v-if="$can('do','POKO_Vouchery_Edycja')"  @click="editVoucher(props.item)" title="Edytuj voucher">fa-edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12" md="12" sm="12">
        <v-card>
          <v-card-title>Nadpłaty</v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" lg="6" md="6" sm="12" align-self="end">
                  <v-text-field label="Kwota" v-model.number="kwota_nadplaty" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" lg="3" md="3" sm="6" align-self="end">
                  <v-radio-group v-model="paymentType">
                    <v-radio :value="0"
                             label="Gotówka"></v-radio>
                    <v-radio :value="1"
                             label="Karta"></v-radio>
                    <v-radio :value="2"
                             label="Przelew"></v-radio>
                    <v-radio :value="5"
                             label="Inne"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="6" class="text-right" align-self="end">
                  <v-btn color="primary" @click="addNadplata" :disabled="kwota_nadplaty<=0">Dodaj nadpłate</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="showEditPopup" width="1024" persistent>
        <VoucherKlientEdycja v-if="showEditPopup"  @close="closeEditDialog" :voucher="editedItem"></VoucherKlientEdycja>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import {voucheryService} from "@/services/vouchery.service";
import swal from "sweetalert";
import dayjs from "dayjs";
import VoucherKlientEdycja from "@/components/clients/VoucherKlientEdycja";


export default {
  name: "VoucheryKlienta",
  components: {VoucherKlientEdycja},
  props: ["clientid"],

  data() {
    return {
      voucherList: [],
      showZuzyte: false,
      loading: false,
      paymentType: 0,
      editedItem: null,
      showEditPopup: false,
      kwota_nadplaty: 0,
      headers: [
        {text: 'Nazwa vouchera',  align: 'left', value: 'nazwa'},
        {text: 'Typ vouchera', align: 'left', value:'typ'},
        {text: 'Numer',  align: 'left', value: 'numer'},
        {text: 'Cena',  align: 'left', value: 'kwota'},
        {text: 'Data sprzedazy',  align: 'left', value: 'data_sprzedazy'},
        {text: 'Ważność vouchera', align: 'left', value: 'kiedy_wygasa'},
        {text: 'Wartość', align: 'left', value: 'id'},
        {text: 'Sprzedawca', align: 'left',value: 'sprzedawca'},
        {text: 'Wykorzystany', align: 'left', value: 'zuzyty'},
        {text: 'Akcje', align: 'left', value: 'id'},
      ],
    }
  },
  mounted() {
    this.getVouchery()
  },
  watch: {
    showZuzyte(val) {
      this.getVouchery()
    },
  },
  methods: {
    getTypOpis(item)
    {
      switch(item.typ)
      {
        case 0:
          return 'Wizyta';
        case 1:
          return 'Czas';
        case 2:
          return 'Kwota';
      }
      return ''
    },
    addNadplata()
    {
      if(this.kwota_nadplaty > 0)
      {
        voucheryService.addNadplata({
          client_id: this.clientid,
          kwota: this.kwota_nadplaty,
          payment_type: this.paymentType
        }).then(() => {
          this.getVouchery()
          this.paymentType = 0
          this.kwota_nadplaty = 0
        }).catch(resp=> {
          if (
              resp.response != null &&
              resp.response.data != null &&
              resp.response.data.error != null
          ) {
            this.showError( resp.response.data.error.message);
          } else {
            this.showError("Nie można dodać nadpłaty");
          }
        })
      }
    },
    getWartosc(item)
    {
      switch(item.typ)
      {
        case 0:
          return item.wykorzystana_ilosc+ '/'+item.dostepna_ilosc + ' wizyt';
        case 1:
          return item.wykorzystane_minuty+ '/'+item.dostepne_minuty +' minut';
        case 2:
          return item.wykorzystana_kwota+ '/'+item.dostepna_kwota+' zł';
      }
      return ''
    },
    dateTimeFormat(val,formattime,defaultval)
    {
      if(val)
      {
        if(formattime) {
          return dayjs(val).format('DD-MM-YYYY HH:mm')
        }
        else
        {
          return dayjs(val).format('DD-MM-YYYY')
        }
      }

      if(defaultval && defaultval.length > 0)
        return defaultval

      return ''
    },
    getVouchery()
    {
      this.loading = true
      voucheryService.getVoucheryKlientaLista({
        clientid: this.clientid,
        showZuzyte: this.showZuzyte
      }).then(result => {
        this.voucherList = result.data.result
        this.loading = false
      }).catch(()=>{
        this.showError('Błąd pobierania listy voucherów klienta')
        this.loading = false
      })
    },
    editVoucher(item)
    {
      this.editedItem = item
      this.showEditPopup = true
    },
    closeEditDialog()
    {
      this.editedItem = null
      this.showEditPopup = false
      this.getVouchery()
    },
    removeVoucher(item)
    {
      if(item.wykorzystana_ilosc > 0 || item.wykorzystana_kwota > 0 || item.wykorzystane_minuty > 0)
      {
        this.showError('Nie można usunąć vouchera który został wykorzystany już do opłacania wizyty.')
        return
      }
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć ten voucher, ta operacja jest nieodwracalna?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          voucheryService.deleteKlientVoucher(item.id)
              .then(() => {
                this.getVouchery()
              }).catch(resp => {
                if (
                  resp.response != null &&
                  resp.response.data != null &&
                  resp.response.data.error != null
                ) {
                  this.showError( resp.response.data.error.message);
                } else {
                  this.showError("Nie można usunąć vouchera");
                }

          });
        }
      });
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    }
  }
}
</script>

<style scoped>

</style>